import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_DETALLE_MERCADERIA_FUMIGADA } from '../../../../config/tables'

function TablaDetalleMercaderiaFumigadaView () {
  return (
    <MuiTable id={TABLA_DETALLE_MERCADERIA_FUMIGADA} />
  )
}

export default TablaDetalleMercaderiaFumigadaView
